<div class="intro">
  <div class="intro-header">
    <div class="title">Samsung Account Developer Console</div>
    <div class="description">Set up and validate your SA Client Application quickly and securely!</div>
    <div class="group-button">
      <sdc-design-button
        type="white"
        title="Get started"
        width="240px"
        height="40px"
        class="intro-button"
        routerLink="/resources"
        (click)="changeStatusMenu()"
      ></sdc-design-button>
      <sdc-design-button
        type="white"
        title="Create Project"
        width="240px"
        height="40px"
        *ngIf="!logged"
        class="intro-button"
        (click)="handlePopup()"
      ></sdc-design-button>
      <sdc-design-button
        type="white"
        title="Your Projects"
        width="240px"
        height="40px"
        *ngIf="logged"
        routerLink="/project"
        class="intro-button"
      ></sdc-design-button>
      <sdc-design-button
        type="white"
        title="Register existing App ID"
        width="240px"
        height="40px"
        *ngIf="logged"
        (click)="handleMigrateClient()"
        class="intro-button"
      ></sdc-design-button>
    </div>
  </div>
  <div class="into-container">
    <div class="intro-content">
      <div class="intro-item">
        <div class="img create-project-id"></div>
        <div class="content">
          <div class="label-text">Create a OAuth client easily</div>
          <div class="content-text">
            Developers can easily and remotely create, manage, edit and delete OAuth client IDs with our powerful web
            tools.
          </div>
        </div>
      </div>
      <div class="intro-item scopes">
        <div class="img secure-app"></div>
        <div class="content">
          <div class="label-text">Secure your apps</div>
          <div class="content-text">
            Samsung Account supports the latest security framework (OAuth 2.0 and OpenID Connect) which enables a
            third-party application to obtain secure and limited access to an HTTP service
          </div>
        </div>
      </div>
      <div class="intro-item">
        <div class="img api-support"></div>
        <div class="content">
          <div class="label-text">Selected Samsung API support</div>
          <div class="content-text">
            Supports APIs for Samsung Account, Samsung Smart Things and other selected services. Enables management from
            one central location.
          </div>
        </div>
      </div>
      <div class="intro-item">
        <div class="img tech-support"></div>
        <div class="content">
          <div class="label-text">Technical support</div>
          <div class="content-text">
            Provides technical supports and guides for authorizing and integrating a web, mobile and server-side
            applications with Samsung account.
          </div>
        </div>
      </div>
    </div>
    <div class="intro-content ss-wrap">
      <div class="intro-item intro-samsung-services">
        <div class="samsung-services">
          <div class="label-text">Samsung services</div>
          <div class="content-text">
            Our developer console empowers developers to integrate their products with some of the most popular Samsung
            services:
          </div>
        </div>
        <div class="service-list">
          <div class="left-table">
            <div class="service-item">
              <div class="img-app samsung-account-img"></div>
              <div class="des-app">
                <div class="name">Samsung Account</div>
                <div class="des">How to enjoy Galaxy to the fullest</div>
              </div>
            </div>
            <div class="service-item">
              <div class="img-app samsung-pay-img"></div>
              <div class="des-app">
                <div class="name">Samsung Pay</div>
                <div class="des">Turn your phone into your wallet</div>
              </div>
            </div>
            <div class="service-item">
              <div class="img-app smart-things-img"></div>
              <div class="des-app smart-things-store">
                <div class="name">SmartThings</div>
                <div class="des">Monitor and control your devices. Anytime, anywhere.</div>
              </div>
            </div>
          </div>
          <div class="right-table">
            <div class="service-item">
              <div class="img-app samsung-health-img"></div>
              <div class="des-app">
                <div class="name">Samsung Health</div>
                <div class="des">Live better, stay healthy</div>
              </div>
            </div>
            <div class="service-item">
              <div class="img-app galaxy-store-img"></div>
              <div class="des-app galaxy-store">
                <div class="name">Galaxy Store</div>
                <div class="des">Get exclusive apps for your phone</div>
              </div>
            </div>
            <div class="service-item">
              <div class="img-app bixby-img"></div>
              <div class="des-app bixby">
                <div class="name">Bixby</div>
                <div class="des">A new way to interact with your phone</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #loginRequired>
  <a class="close" [mat-dialog-close]>
    <img class="close-icon" src="/assets/images/icons/close-icon.png" alt="close-icon" />
  </a>
  <div class="modal-body">In order to create the project you need to sign into your Samsung Account</div>
  <div class="modal-footer">
    <a *ngIf="!logged" (click)="handleLogin()">
      <cc-button [title]="'Continue'" [type]="'blue'"></cc-button>
    </a>
  </div>
</ng-template>
